import { useState } from 'react'
import { useCollection } from '../hooks/useFirestore'
import CharacterCard from '../components/characters/CharacterCard'
import './CharactersPage.css'

export default function CharactersPage() {
  const [activeTab, setActiveTab] = useState('pc')
  const { data: characters, loading, error } = useCollection('characters', { orderByField: 'sortOrder' })

  // Filter out hidden characters from public view
  const visibleCharacters = characters.filter(c => c.hidden !== true)

  const pcs = visibleCharacters.filter(c => c.type === 'pc')
  const npcs = visibleCharacters.filter(c => c.type === 'npc')

  if (loading) {
    return (
      <div className="container">
        <div className="characters-loading">
          <div className="loading-spinner" />
          <p>Loading characters...</p>
        </div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="container">
        <div className="characters-error">
          <h2>Error loading characters</h2>
          <p>{error}</p>
        </div>
      </div>
    )
  }

  const displayedCharacters = activeTab === 'pc' ? pcs : npcs

  return (
    <div className="container">
      <h1>Characters</h1>

      <div className="character-tabs">
        <button
          className={`tab-button ${activeTab === 'pc' ? 'active' : ''}`}
          onClick={() => setActiveTab('pc')}
        >
          Party Members
          <span className="tab-count">{pcs.length}</span>
        </button>
        <button
          className={`tab-button ${activeTab === 'npc' ? 'active' : ''}`}
          onClick={() => setActiveTab('npc')}
        >
          NPCs
          <span className="tab-count">{npcs.length}</span>
        </button>
      </div>

      {displayedCharacters.length === 0 ? (
        <div className="characters-empty">
          <p>No {activeTab === 'pc' ? 'party members' : 'NPCs'} yet.</p>
          <p className="text-secondary">Add characters from the Admin section.</p>
        </div>
      ) : (
        <div className="characters-grid">
          {displayedCharacters.map(character => (
            <CharacterCard key={character.id} character={character} />
          ))}
        </div>
      )}
    </div>
  )
}
